import { StickableUIData } from "./stickableUIData";

export class CompositeUIData  extends StickableUIData {
  public readonly SIDEBAR_EXTENDED = "sidebarExtended";

  get sidebarExtended(): boolean { return this.getInternalValue<boolean>(this.SIDEBAR_EXTENDED); }
  setSidebarExtended(sidebarExtended: boolean): this { return this.setInternalValue(this.SIDEBAR_EXTENDED, sidebarExtended); }  
}